<template>
  <div v-if="programaId" class="section-card">
    <p class="section-title mb-0 mt-3 pa-1 pl-5">
      Definir Títulos Intermedios:
      <a class="btn btn-default section-toggle" data-toggle="collapse" href="#collapsepostitulos">expandir</a>
    </p>
    <div class="collapse section-body" id="collapsepostitulos">
      <p class="text-center blue--text mb-1">
        Al definir certificaciones los programas tendrán la opción de seleccionar con cuál certificado serán generados.
      </p>
      <v-progress-linear indeterminate class="mt-0 mb-4" v-if="loadingpostitulos" />

      <v-row no-gutters v-if="postitulos.length">
        <v-col cols="8" offset-sm="1" class="mb-6">
          <Universidades :model="postitulouni" :convenio="true" :xdefault="postitulodefaultuniv" />
          <label class="green--text ml-1">Seleccione la Universidad de certificacion</label>
        </v-col>
      </v-row>

      <div v-for="(po, indx) in postitulos" :key="indx">
        <v-row no-gutters>
          <v-col cols="8" offset-sm="1">
            <v-text-field v-model.trim="po.postitulo" label="* Titulo de certificacion:"
              placeholder="max 200 caracteres..." :prefix="'' + (indx + 1)"
              class="mb-4" hide-details outlined dense />
          </v-col>
          <v-col cols="3">
            <v-text-field v-model.number="po.horas_academicas" type="number"
              label="* Carga Horaria:" placeholder="0...999" prefix="Horas:"
              class="mb-4" style="margin-left:.2em" hide-details outlined dense />
          </v-col>
        </v-row>
      </div>

      <button type="button" :disabled="!isPostgrado || onlyReadAcade"
        class="btn btn-sm btn-success white--text ml-4" @click="$emit('add-postitulo', true)">
        + agregar certificacion
      </button>
      <button type="button" :disabled="!isPostgrado || onlyReadAcade"
        class="btn btn-sm btn-danger white--text" @click="$emit('add-postitulo', false)">
        - quitar certificacion
      </button>
      <hr class="mb-8 mt-1 blue" />
    </div>
  </div>
  <p v-else class="grey mb-8 mt-14 pa-1 section-title">
    <b>NOTA:</b> Para definir los títulos intermedios primero debe crear el programa.
  </p>
</template>

<script>
import Universidades from '@/components/AUniversidades.vue';
export default {
  name: 'SeccionPostitulos',
  components: { Universidades },
  props: {
    programaId: { default: null },
    postitulos: { type: Array, default: () => [] },
    postitulouni: { type: Object, default: () => ({ iduniversidad: null }) },
    postitulodefaultuniv: { default: null },
    loadingpostitulos: { type: Boolean, default: false },
    isPostgrado: { type: Boolean, default: false },
    onlyReadAcade: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.section-card { background:#fff; border:1px solid #e6e9f0; border-radius:12px; padding:14px 14px 6px; margin-top:16px; box-shadow:0 4px 12px rgba(0,0,0,.04); }
.section-title { display:flex; align-items:center; justify-content:space-between; border-radius:10px; background:linear-gradient(90deg,#e3f2fd 0%,#ede7f6 100%); color:#1e3a8a; font-weight:600; }
.section-toggle { color:#3949ab; font-weight:600; }
.section-body { padding-top:10px; }
</style>
